import React, { useEffect, useState } from "react";
import useUpload from "../../../../../hooks/useUpload";
import ErrorModal from "./ErrorModal";

const ControlIcons = ({ setQrOptions, qrOptions, toggleModal }) => {
    const appSiteUrl = process.env.REACT_APP_SITE_URL;
    const { handleUpload, uploadedFileUrl, error, forceUpdate } = useUpload();
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

    const handleIconClick = (iconUrl) => {
        setQrOptions(prevOptions => ({ ...prevOptions, image: iconUrl }));
    };

    const handleImageUpload = (event) => {
        handleUpload(event);
        event.target.value = null; // Limpar o valor do input de arquivo
    };

    useEffect(() => {
        if (uploadedFileUrl) {
            setQrOptions(prevOptions => ({ ...prevOptions, image: uploadedFileUrl }));
        }
    }, [uploadedFileUrl, setQrOptions, forceUpdate]);

    useEffect(() => {
        if (error) {
            setIsErrorModalOpen(true);
        }
    }, [error, forceUpdate]);

    return (
        <div className="icon-controls-container">
            <div className="icon-controls">
                <img src={`${appSiteUrl}/imagens/Instagram.webp`} alt="Instagram" className="icon" onClick={() => handleIconClick(`${appSiteUrl}/imagens/Instagram.webp`)} />
                <img src={`${appSiteUrl}/imagens/FaceBook.webp`} alt="Facebook" className="icon" onClick={() => handleIconClick(`${appSiteUrl}/imagens/FaceBook.webp`)} />
                <img src={`${appSiteUrl}/imagens/WhatsApp.webp`} alt="WhatsApp" className="icon" onClick={() => handleIconClick(`${appSiteUrl}/imagens/WhatsApp.webp`)} />
                <img src={`${appSiteUrl}/imagens/Gmail.webp`} alt="E-mail" className="icon" onClick={() => handleIconClick(`${appSiteUrl}/imagens/Gmail.webp`)} />
                <img src={`${appSiteUrl}/imagens/PIX.webp`} alt="E-mail" className="icon" onClick={() => handleIconClick(`${appSiteUrl}/imagens/PIX.webp`)} />
            </div>
            <div className="icon-buttons">
                <button className="btn" onClick={() => handleIconClick(null)}>Remover Imagem</button>
                <input type="file" onChange={handleImageUpload} style={{ display: 'none' }} id="upload-input" />
                <label htmlFor="upload-input" className="btn btn-upload">Upload Image</label>
            </div>
            <ErrorModal
                isOpen={isErrorModalOpen}
                onClose={() => setIsErrorModalOpen(false)}
                errorMessage={error}
            />
        </div>
    );
};

export default ControlIcons;